import { createApp } from "vue";
import App from "./App.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
// @ts-expect-error missing types
import VueMatomo from "vue-matomo";
import "@vuepic/vue-datepicker/dist/main.css";

const app = createApp(App);

app
  .use(VueMatomo, {
    host: 'https://matomo.pocket-rocket.io',
    siteId: 4,
  })

  .mount("#app");

app.component("VueDatePicker", VueDatePicker);

app.mount("#app50");
